import {Card, FormControl, FormHelperText, FormLabel, Input, Stack, Typography} from "@mui/joy";
import React, {useEffect} from "react";
import {useSettings} from "../../hooks/useSettings";
import {UserFormData} from "../../models/user";
import {LockIcon} from "lucide-react";
import {useTranslation} from "react-i18next";

const SecuritySettingsSection = () => {
    const settings = useSettings()
    const {t} = useTranslation()

    const fieldValidation: {
        [key in "newPassword" | "oldPassword" | "confirmNew"]: {
            required: boolean,
            message?: string,
            check?: boolean
        }
    } = {
        oldPassword: {
            check: settings?.password.oldPassword?.length >= 6,
            message: t("invalidPasswordFieldMessage"),
            required: true
        },
        newPassword: {
            check: settings?.password.newPassword?.length >= 6,
            message: t("invalidPasswordFieldMessage"),
            required: true
        },
        confirmNew: {
            check: settings?.password.newPassword === settings.password.confirmNew,
            message: t("invalidConfirmPasswordMessage"),
            required: true
        },
    }

    const validateForm = () => {
        settings.setFieldsValid(Object.keys(fieldValidation)?.every(value =>
            fieldValidation[value].required ? !!settings.userFormData[value] && fieldValidation[value].check : !settings.userFormData[value] || fieldValidation[value].check))
    }

    useEffect(() => {
        validateForm()
    }, [settings.userFormData])


    return <Stack gap={2}>
        <Card data-no-glow data-no-animation sx={{padding: 3}}>
            <Typography level={"title-md"}>
                {t("updatePasswordFieldLabel")}
            </Typography>

            <FormControl error={settings.password.oldPassword && !fieldValidation.oldPassword.check}>
                <FormLabel>
                    {t("oldPasswordFieldLabel")}
                </FormLabel>
                <Input size={"lg"} startDecorator={<LockIcon/>}
                       value={settings.password.oldPassword}
                       onChange={(event) => settings.onPasswordInfoChange({
                           ...settings.password,
                           oldPassword: event.target.value
                       })}
                       placeholder={t("oldPasswordFieldPlaceholder")}
                       type={"password"}/>

                <FormHelperText>
                    {(settings.password.oldPassword && !fieldValidation.oldPassword.check) ? fieldValidation.oldPassword.message : "at least 6 characters"}
                </FormHelperText>
            </FormControl>

            <FormControl error={settings.password.newPassword && !fieldValidation.newPassword.check}>
                <FormLabel>
                    {t("newPasswordFieldLabel")}
                </FormLabel>
                <Input size={"lg"} startDecorator={<LockIcon/>}
                       value={settings.password.newPassword}
                       onChange={(event) => settings.onPasswordInfoChange({
                           ...settings.password,
                           newPassword: event.target.value
                       })}
                       placeholder={t("newPasswordFieldPlaceholder")}
                       type={"password"}/>

                <FormHelperText>
                    {(settings.password.newPassword && !fieldValidation.newPassword.check) ? fieldValidation.newPassword.message : "at least 6 characters"}
                </FormHelperText>
            </FormControl>

            <FormControl
                error={(settings.password.confirmNew && !fieldValidation.confirmNew.check)}>
                <FormLabel>
                    {t("confirmPasswordFieldLabel")}
                </FormLabel>
                <Input size={"lg"} startDecorator={<LockIcon/>}
                       value={settings.password.confirmNew}
                       onChange={(event) => settings.onPasswordInfoChange({
                           ...settings.password,
                           confirmNew: event.target.value
                       })}
                       placeholder={t("confirmNewPasswordFieldPlaceholder")}
                       type={"password"}/>

                {(settings.password.confirmNew && !fieldValidation.confirmNew.check) &&
                    <FormHelperText>
                        {fieldValidation.confirmNew.message}
                    </FormHelperText>}
            </FormControl>

        </Card>
    </Stack>
}


export default SecuritySettingsSection